<div class="tablet:flex tablet:justify-between tablet:items-center mb-4  tablet:mb-5 desktop:mb-6">
    <h1 class="text-mobileH1 tablet:text-tabletH1  font-headline text-black text-mobileBodyH1  desktop:text-desktopH1 ">
        {{ title }}
    </h1>
    <ng-content></ng-content>
</div>
